import React, { useState } from 'react';
import { ArrowLeft, Star, ShoppingCart, Minus, Plus, Truck, Shield, RotateCcw } from 'lucide-react';
import { useCart } from '../contexts/CartContext';
import MiniCart from '../components/MiniCart';
import CheckoutPage from './CheckoutPage';

interface ProductDetailPageProps {
  productId?: string;
  onBack?: () => void;
}

const ProductDetailPage: React.FC<ProductDetailPageProps> = ({ productId, onBack }) => {
  const [selectedImage, setSelectedImage] = useState(0);
  const [quantity, setQuantity] = useState(1);
  const [activeTab, setActiveTab] = useState<'detail' | 'specs' | 'reviews'>('detail');
  const [showMiniCart, setShowMiniCart] = useState(false);
  const [showCheckout, setShowCheckout] = useState(false);
  
  const { addToCart, cartItems, updateQuantity, removeFromCart } = useCart();

  // 模拟商品数据库
  const productsDatabase = {
    1: {
      id: 1,
      name: '小苍娃汆味呛鼻子登封小苍娃芥丝辣疙瘩丝介菜开胃咸菜下饭菜河南味道 500克芥丝3袋共3斤',
      price: 25.4,
      originalPrice: 38.8,
      images: [
        '/images/jiecaisi.jpg',
        '/images/jiecaisi.jpg',
        '/images/jiecaisi.jpg',
        '/images/jiecaisi.jpg'
      ],
      sales: 1234,
      rating: 4.8,
      reviewCount: 156,
      stock: 999,
      brand: '小苍娃',
      origin: '河南登封',
      weight: '500g × 3袋',
      expiryDate: '12个月',
      storage: '常温避光保存',
      description: '采用传统工艺制作，选用优质芥菜，口感脆嫩，开胃下饭，是河南特色美食。',
      features: [
        '传统工艺制作',
        '选用优质芥菜',
        '口感脆嫩',
        '开胃下饭',
        '河南特色美食'
      ],
      specifications: {
        '品牌': '小苍娃',
        '产地': '河南登封',
        '净含量': '500g × 3袋',
        '保质期': '12个月',
        '储存方法': '常温避光保存',
        '配料': '芥菜、食用盐、辣椒、调味料',
        '执行标准': 'GB/T 5009.44',
        '生产许可证': 'SC10641018500001'
      },
      reviews: [
        {
          id: 1,
          user: '张**',
          rating: 5,
          date: '2024-01-15',
          content: '味道很好，很开胃，包装也很不错，会继续购买！',
          images: []
        },
        {
          id: 2,
          user: '李**',
          rating: 4,
          date: '2024-01-14',
          content: '口感脆嫩，辣度适中，下饭神器，推荐购买。',
          images: []
        },
        {
          id: 3,
          user: '王**',
          rating: 5,
          date: '2024-01-13',
          content: '河南特产，正宗味道，包装精美，物流很快。',
          images: []
        }
      ]
    },
    2: {
      id: 2,
      name: '雅朴善太室本草黄精茶 道地养生茶 养生茶一盒',
      price: 199,
      originalPrice: 599.00,
      images: [
        '/images/huangjingcha.jpg',
        '/images/huangjingcha.jpg',
        '/images/huangjingcha.jpg',
        '/images/huangjingcha.jpg'
      ],
      sales: 856,
      rating: 4.6,
      reviewCount: 89,
      stock: 567,
      brand: '雅朴善',
      origin: '河南太室山',
      weight: '50g × 1盒',
      expiryDate: '24个月',
      storage: '密封避光保存',
      description: '采用太室山野生黄精，传统工艺制作，具有滋阴润肺、补气养血的功效。',
      features: [
        '野生黄精原料',
        '传统工艺制作',
        '滋阴润肺',
        '补气养血',
        '道地药材'
      ],
      specifications: {
        '品牌': '雅朴善',
        '产地': '河南太室山',
        '净含量': '50g × 1盒',
        '保质期': '24个月',
        '储存方法': '密封避光保存',
        '配料': '黄精',
        '执行标准': 'GB/T 5009.44',
        '生产许可证': 'SC10641018500002'
      },
      reviews: [
        {
          id: 1,
          user: '陈**',
          rating: 5,
          date: '2024-01-15',
          content: '黄精茶味道很好，养生效果明显，包装精美，推荐购买！',
          images: []
        },
        {
          id: 2,
          user: '刘**',
          rating: 4,
          date: '2024-01-14',
          content: '茶香浓郁，口感醇厚，是很好的养生茶品。',
          images: []
        }
      ]
    },
    3: {
      id: 3,
      name: '张弓大汉盛运 浓香型白酒 52度 500ml*6瓶 整箱装',
      price: 910,
      originalPrice: 980,
      images: [
        '/images/zhanggongjiu.jpg',
        '/images/zhanggongjiu.jpg',
        '/images/zhanggongjiu.jpg',
        '/images/zhanggongjiu.jpg'
      ],
      sales: 567,
      rating: 4.5,
      reviewCount: 234,
      stock: 1234,
      brand: '张弓',
      origin: '河南商丘',
      weight: '500ml × 6瓶',
      expiryDate: '长期',
      storage: '常温避光保存',
      description: '张弓酒业经典产品，采用传统酿造工艺，酒香浓郁，口感醇厚。',
      features: [
        '传统酿造工艺',
        '酒香浓郁',
        '口感醇厚',
        '52度高度酒',
        '整箱装'
      ],
      specifications: {
        '品牌': '张弓',
        '产地': '河南商丘',
        '净含量': '500ml × 6瓶',
        '酒精度': '52%vol',
        '保质期': '长期',
        '储存方法': '常温避光保存',
        '配料': '水、高粱、小麦、玉米',
        '执行标准': 'GB/T 10781.1',
        '生产许可证': 'SC10641018500003'
      },
      reviews: [
        {
          id: 1,
          user: '赵**',
          rating: 5,
          date: '2024-01-15',
          content: '张弓酒味道很好，酒香浓郁，送礼自饮都很合适！',
          images: []
        },
        {
          id: 2,
          user: '孙**',
          rating: 4,
          date: '2024-01-14',
          content: '包装精美，酒质不错，性价比很高。',
          images: []
        }
      ]
    },
    4: {
      id: 4,
      name: '鲲满坊贵州茅台镇 酱香型白酒 坤沙高粱酒整箱纯粮食53度品鉴酒 53度 500mL 6瓶 坤沙鉴赏酒',
      price: 586,
      originalPrice: 698,
      images: [
        '/images/kunmanfang.jpg',
        '/images/kunmanfang.jpg',
        '/images/kunmanfang.jpg',
        '/images/kunmanfang.jpg'
      ],
      sales: 432,
      rating: 4.7,
      reviewCount: 156,
      stock: 789,
      brand: '鲲满坊',
      origin: '贵州茅台镇',
      weight: '500mL × 6瓶',
      expiryDate: '长期',
      storage: '常温避光保存',
      description: '贵州茅台镇酱香型白酒，采用坤沙工艺，酒体醇厚，酱香突出。',
      features: [
        '茅台镇酱香型',
        '坤沙工艺',
        '酒体醇厚',
        '酱香突出',
        '纯粮食酿造'
      ],
      specifications: {
        '品牌': '鲲满坊',
        '产地': '贵州茅台镇',
        '净含量': '500mL × 6瓶',
        '酒精度': '53%vol',
        '保质期': '长期',
        '储存方法': '常温避光保存',
        '配料': '水、高粱、小麦',
        '执行标准': 'GB/T 26760',
        '生产许可证': 'SC10641018500004'
      },
      reviews: [
        {
          id: 1,
          user: '周**',
          rating: 5,
          date: '2024-01-15',
          content: '茅台镇酱香酒，味道正宗，酒香浓郁，值得收藏！',
          images: []
        },
        {
          id: 2,
          user: '吴**',
          rating: 4,
          date: '2024-01-14',
          content: '酱香型白酒，口感不错，包装也很精美。',
          images: []
        }
      ]
    }
  };

  // 根据productId获取商品信息
  const productIdNumber = productId ? parseInt(productId) : 1;
  const product = productsDatabase[productIdNumber as keyof typeof productsDatabase] || productsDatabase[1];

  const handleQuantityChange = (type: 'increase' | 'decrease') => {
    if (type === 'increase' && quantity < product.stock) {
      setQuantity(quantity + 1);
    } else if (type === 'decrease' && quantity > 1) {
      setQuantity(quantity - 1);
    }
  };

  const renderImageGallery = () => (
    <div className="bg-white p-4">
      {/* 主图 */}
      <div className="w-full h-80 bg-gray-100 rounded-lg mb-4 overflow-hidden">
        <img 
          src={product.images[selectedImage]} 
          alt={product.name}
          className="w-full h-full object-cover"
          onError={(e) => {
            e.currentTarget.style.display = 'none';
            e.currentTarget.nextElementSibling?.classList.remove('hidden');
          }}
        />
        {/* 备用显示 */}
        <div className={`w-full h-full flex items-center justify-center text-6xl ${product.images[selectedImage]?.startsWith('/') ? 'hidden' : ''}`}>
          🍽️
        </div>
      </div>
      
      {/* 缩略图 */}
      <div className="flex space-x-2 overflow-x-auto">
        {product.images.map((image, index) => (
          <button
            key={index}
            onClick={() => setSelectedImage(index)}
            className={`flex-shrink-0 w-16 h-16 rounded-lg overflow-hidden border-2 ${
              selectedImage === index ? 'border-primary' : 'border-gray-200'
            }`}
          >
            <img 
              src={image} 
              alt={`${product.name} ${index + 1}`}
              className="w-full h-full object-cover"
              onError={(e) => {
                e.currentTarget.style.display = 'none';
                e.currentTarget.nextElementSibling?.classList.remove('hidden');
              }}
            />
            {/* 备用显示 */}
            <div className={`w-full h-full flex items-center justify-center text-lg ${image?.startsWith('/') ? 'hidden' : ''}`}>
              🍽️
            </div>
          </button>
        ))}
      </div>
    </div>
  );

  const renderProductInfo = () => (
    <div className="bg-white p-4 border-t">
      <h1 className="text-lg font-semibold text-gray-800 mb-3 leading-tight">
        {product.name}
      </h1>
      
      {/* 价格和评分 */}
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center space-x-2">
          <span className="text-2xl font-bold text-red-600">¥{product.price}</span>
          <span className="text-gray-400 line-through">¥{product.originalPrice}</span>
        </div>
        <div className="flex items-center space-x-1">
          <Star size={16} className="text-yellow-400 fill-current" />
          <span className="text-sm text-gray-600">{product.rating}</span>
          <span className="text-sm text-gray-400">({product.reviewCount}条评价)</span>
        </div>
      </div>
      
      {/* 销量和库存 */}
      <div className="flex items-center justify-between text-sm text-gray-500 mb-4">
        <span>已售 {product.sales}</span>
        <span>库存 {product.stock}</span>
      </div>
      
      {/* 基本信息 */}
      <div className="space-y-2 text-sm text-gray-600 mb-4">
        <div className="flex justify-between">
          <span>品牌：</span>
          <span>{product.brand}</span>
        </div>
        <div className="flex justify-between">
          <span>产地：</span>
          <span>{product.origin}</span>
        </div>
        <div className="flex justify-between">
          <span>净含量：</span>
          <span>{product.weight}</span>
        </div>
      </div>
      
      {/* 数量选择 */}
      <div className="flex items-center justify-between mb-4">
        <span className="text-sm text-gray-600">数量：</span>
        <div className="flex items-center space-x-3">
          <button
            onClick={() => handleQuantityChange('decrease')}
            disabled={quantity <= 1}
            className="p-1 rounded-full border border-gray-300 disabled:opacity-50"
          >
            <Minus size={16} />
          </button>
          <span className="w-12 text-center">{quantity}</span>
          <button
            onClick={() => handleQuantityChange('increase')}
            disabled={quantity >= product.stock}
            className="p-1 rounded-full border border-gray-300 disabled:opacity-50"
          >
            <Plus size={16} />
          </button>
        </div>
      </div>
      
      {/* 服务保障 */}
      <div className="flex items-center space-x-4 text-sm text-gray-500 mb-4">
        <div className="flex items-center space-x-1">
          <Truck size={16} />
          <span>包邮</span>
        </div>
        <div className="flex items-center space-x-1">
          <Shield size={16} />
          <span>正品保证</span>
        </div>
        <div className="flex items-center space-x-1">
          <RotateCcw size={16} />
          <span>7天退换</span>
        </div>
      </div>
    </div>
  );

  const renderTabs = () => (
    <div className="bg-white border-t">
      <div className="flex border-b">
        {[
          { id: 'detail', label: '商品详情' },
          { id: 'specs', label: '规格参数' },
          { id: 'reviews', label: '用户评价' }
        ].map((tab) => (
          <button
            key={tab.id}
            onClick={() => setActiveTab(tab.id as any)}
            className={`flex-1 py-3 text-sm font-medium ${
              activeTab === tab.id
                ? 'text-primary border-b-2 border-primary'
                : 'text-gray-500'
            }`}
          >
            {tab.label}
          </button>
        ))}
      </div>
      
      <div className="p-4">
        {activeTab === 'detail' && (
          <div className="space-y-4">
            <h3 className="font-semibold text-gray-800">商品特色</h3>
            <ul className="space-y-2">
              {product.features.map((feature, index) => (
                <li key={index} className="flex items-center space-x-2">
                  <div className="w-2 h-2 bg-primary rounded-full"></div>
                  <span className="text-gray-600">{feature}</span>
                </li>
              ))}
            </ul>
            
            <h3 className="font-semibold text-gray-800">商品描述</h3>
            <p className="text-gray-600 leading-relaxed">{product.description}</p>
            
            <h3 className="font-semibold text-gray-800">商品图片</h3>
            <div className="space-y-3">
              {product.images.map((image, index) => (
                <div key={index} className="w-full bg-gray-100 rounded-lg overflow-hidden">
                  <img 
                    src={image} 
                    alt={`${product.name} ${index + 1}`}
                    className="w-full h-auto object-cover"
                    onError={(e) => {
                      e.currentTarget.style.display = 'none';
                      e.currentTarget.nextElementSibling?.classList.remove('hidden');
                    }}
                  />
                  {/* 备用显示 */}
                  <div className={`w-full h-32 flex items-center justify-center text-4xl ${image?.startsWith('/') ? 'hidden' : ''}`}>
                    🍽️
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
        
        {activeTab === 'specs' && (
          <div className="space-y-3">
            {Object.entries(product.specifications).map(([key, value]) => (
              <div key={key} className="flex justify-between py-2 border-b border-gray-100">
                <span className="text-gray-600">{key}</span>
                <span className="text-gray-800">{value}</span>
              </div>
            ))}
          </div>
        )}
        
        {activeTab === 'reviews' && (
          <div className="space-y-4">
            {product.reviews.map((review) => (
              <div key={review.id} className="border-b border-gray-100 pb-4">
                <div className="flex items-center justify-between mb-2">
                  <div className="flex items-center space-x-2">
                    <span className="text-gray-800">{review.user}</span>
                    <div className="flex items-center space-x-1">
                      {[...Array(5)].map((_, i) => (
                        <Star 
                          key={i} 
                          size={14} 
                          className={i < review.rating ? 'text-yellow-400 fill-current' : 'text-gray-300'} 
                        />
                      ))}
                    </div>
                  </div>
                  <span className="text-sm text-gray-400">{review.date}</span>
                </div>
                <p className="text-gray-600 text-sm leading-relaxed">{review.content}</p>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );

  const renderBottomActions = () => (
    <div className="fixed bottom-20 left-0 right-0 bg-white border-t p-4 flex items-center space-x-3">
      <button 
        onClick={() => setShowMiniCart(true)}
        className="p-3 rounded-full border border-gray-200 text-gray-400 hover:bg-gray-50 transition-colors relative"
      >
        <ShoppingCart size={20} />
        {cartItems.length > 0 && (
          <span className="absolute -top-2 -right-2 bg-red-500 text-white text-xs rounded-full w-5 h-5 flex items-center justify-center">
            {cartItems.reduce((sum, item) => sum + item.quantity, 0)}
          </span>
        )}
      </button>
      
      <button 
        onClick={() => {
          addToCart({
            id: product.id,
            name: product.name,
            price: product.price,
            image: product.images[0]
          });
        }}
        className="flex-1 bg-primary text-white py-3 rounded-lg font-medium hover:bg-blue-600 transition-colors"
      >
        立即购买
      </button>
    </div>
  );

  if (showCheckout) {
    return (
      <CheckoutPage 
        onBack={() => setShowCheckout(false)}
      />
    );
  }

  return (
    <div className="min-h-screen bg-gray-50 pb-32">
      {/* 头部导航 */}
      <div className="bg-white border-b sticky top-0 z-10">
        <div className="flex items-center justify-between p-4">
          <button 
            onClick={onBack}
            className="p-2 hover:bg-gray-100 rounded-full transition-colors"
          >
            <ArrowLeft size={20} className="text-gray-600" />
          </button>
          <h2 className="text-lg font-semibold text-gray-800">商品详情</h2>
          <div className="w-10"></div>
        </div>
      </div>

      {/* 商品图片 */}
      {renderImageGallery()}
      
      {/* 商品信息 */}
      {renderProductInfo()}
      
      {/* 标签页内容 */}
      {renderTabs()}
      
      {/* 底部操作栏 */}
      {renderBottomActions()}
      
            {/* 迷你购物车 */}
      <MiniCart
        isOpen={showMiniCart}
        onClose={() => setShowMiniCart(false)}
        cartItems={cartItems}
        onUpdateQuantity={updateQuantity}
        onRemoveItem={removeFromCart}
        onCheckout={() => {
          setShowMiniCart(false);
          setShowCheckout(true);
        }}
      />
    </div>
  );
};

export default ProductDetailPage;
